export default {
    name: "ProductNote",
}
